import React from 'react';
import { Box, Typography, InputBase } from '@mui/material';

// A single borderless label+input row, meant to be stacked inside a
// FormSection. Accepts standard input props (value, onChange, type,
// placeholder, multiline, ...) via `inputProps`/rest passthrough to InputBase.
export default function FormRow({
  label,
  unit,
  startAdornment,
  endAdornment,
  sx,
  slotProps,
  children,
  ...inputProps
}) {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, px: 2, py: 1.25, minHeight: 44, ...sx }}>
      {label && (
        <Typography variant="body1" color="text.secondary" sx={{ flexShrink: 0, minWidth: 110 }}>
          {label}
        </Typography>
      )}
      {startAdornment}
      {children ?? (
        <InputBase
          fullWidth
          sx={{ fontSize: '1rem', textAlign: label ? 'right' : 'left' }}
          inputProps={slotProps}
          {...inputProps}
        />
      )}
      {unit && (
        <Typography variant="body2" color="text.secondary" sx={{ flexShrink: 0 }}>
          {unit}
        </Typography>
      )}
      {endAdornment}
    </Box>
  );
}
